var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlatform(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 53.983,
    viewBox: "0 0 60 53.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "platform",
    transform: "translate(0 -10.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10994",
    "data-name": "Path 10994",
    d: "M97.651,102.548a2.113,2.113,0,0,0-2.834.948l-5.6,11.237a2.113,2.113,0,1,0,3.782,1.886l5.6-11.237A2.113,2.113,0,0,0,97.651,102.548Z",
    transform: "translate(-63.919 -65.828)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10995",
    "data-name": "Path 10995",
    d: "M166.456,38.192a2.111,2.111,0,1,0-1.493-.62A2.129,2.129,0,0,0,166.456,38.192Z",
    transform: "translate(-118.045 -16.727)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10996",
    "data-name": "Path 10996",
    d: "M139.459,38.192a2.111,2.111,0,1,0-1.5-.62A2.127,2.127,0,0,0,139.459,38.192Z",
    transform: "translate(-98.652 -16.727)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10997",
    "data-name": "Path 10997",
    d: "M112.459,38.192a2.111,2.111,0,1,0-1.5-.62A2.127,2.127,0,0,0,112.459,38.192Z",
    transform: "translate(-79.259 -16.727)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10998",
    "data-name": "Path 10998",
    d: "M57.887,10.678H2.113A2.113,2.113,0,0,0,0,12.791V62.549a2.113,2.113,0,0,0,2.113,2.113H57.887A2.113,2.113,0,0,0,60,62.549V12.791A2.113,2.113,0,0,0,57.887,10.678ZM55.774,14.9V23.8H4.226V14.9ZM4.226,60.436V28.024H55.774V60.436Z",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10999",
    "data-name": "Path 10999",
    d: "M56.6,103.51a2.114,2.114,0,0,0-2.988,0l-5.555,5.555a2.114,2.114,0,0,0,0,2.989l5.533,5.532a2.113,2.113,0,1,0,2.988-2.988l-4.039-4.038L56.6,106.5A2.114,2.114,0,0,0,56.6,103.51Z",
    transform: "translate(-34.076 -66.234)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11000",
    "data-name": "Path 11000",
    d: "M134.478,103.509a2.113,2.113,0,1,0-2.988,2.988l4.038,4.038-4.061,4.061a2.113,2.113,0,0,0,2.989,2.988l5.555-5.555a2.113,2.113,0,0,0,0-2.988Z",
    transform: "translate(-93.985 -66.234)",
    fill: "#d0d0d0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.6583962b86b218542b278bef9d141f69.svg";
export { ForwardRef as ReactComponent };